import { render } from "./MultipleTreeSelect.vue?vue&type=template&id=3972d4c0&scoped=true&ts=true"
import script from "./MultipleTreeSelect.vue?vue&type=script&lang=ts"
export * from "./MultipleTreeSelect.vue?vue&type=script&lang=ts"

import "./MultipleTreeSelect.vue?vue&type=style&index=0&id=3972d4c0&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3972d4c0"]])

export default __exports__